import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import Add from '@mui/icons-material/Add'
import { FormattedMessage } from 'react-intl'
import { isEmpty, get } from 'lodash'

const PageSectionChips = ({
  items,
  emptyId,
  labelField = 'name',
  loading,
  onDelete,
  onAdd,
  addLabelId,
}) => {
  if (loading) {
    return <CircularProgress size={24} />
  }

  const hasItems = !isEmpty(items)

  if (!hasItems && !onAdd) {
    return (
      <Typography variant="body2" color="text.secondary">
        <FormattedMessage id={emptyId} />
      </Typography>
    )
  }

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
      {items.map((item) => {
        const label = get(item, labelField)
        return (
          <Chip
            key={item.id}
            label={label}
            size="small"
            onDelete={onDelete ? () => onDelete(item) : undefined}
          />
        )
      })}
      {onAdd && (
        <Chip
          icon={<Add />}
          label={<FormattedMessage id={addLabelId} />}
          size="small"
          variant="outlined"
          onClick={onAdd}
        />
      )}
    </Box>
  )
}

export default PageSectionChips
